var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.95,
    height: 18.902,
    viewBox: "0 0 23.95 18.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-4613.853-3753.1a2.365,2.365,0,0,1-2.362-2.364v-7.213a3.375,3.375,0,0,0,.441.085h0a4.431,4.431,0,0,0,.6.041,4.394,4.394,0,0,0,1.316-.2v4.925h11.813v-4.921a4.508,4.508,0,0,0,1.308.195,4.453,4.453,0,0,0,.6-.041c.125-.019.306-.048.454-.085v7.213a2.366,2.366,0,0,1-2.363,2.364Zm10.717-11.7a3.242,3.242,0,0,1-2.408,1.07,3.237,3.237,0,0,1-2.406-1.07,3.237,3.237,0,0,1-2.408,1.07,3.239,3.239,0,0,1-2.4-1.07,3.238,3.238,0,0,1-2.408,1.07,3.577,3.577,0,0,1-.447-.029,2.876,2.876,0,0,1-1.916-4.408l2.115-3.347a1.047,1.047,0,0,1,.885-.485h13.171a1.045,1.045,0,0,1,.883.485l2.114,3.347a2.873,2.873,0,0,1-1.923,4.408,3.467,3.467,0,0,1-.446.029A3.235,3.235,0,0,1-4603.136-3764.8Zm8.6-4.376-.958-.958-.958.958a.287.287,0,0,1-.206.086.287.287,0,0,1-.206-.086.292.292,0,0,1,0-.412l.958-.957-.958-.958a.291.291,0,0,1,0-.411.289.289,0,0,1,.412,0l.958.958.958-.958a.292.292,0,0,1,.413,0,.293.293,0,0,1,0,.411l-.958.958.958.958a.292.292,0,0,1,0,.412.291.291,0,0,1-.206.084A.285.285,0,0,1-4594.535-3769.177Z",
    transform: "translate(4617.988 3772)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitestore);
export default __webpack_public_path__ + "static/media/white store.d80fb7243b4d3bfebeb70fbf38fe862f.svg";
export { ForwardRef as ReactComponent };